import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : PURCHASE_ANCHOR} {...isCheckout ? {
    rel: 'noopener'
  } : {}} className={`block w-full rounded-md bg-gold px-3 py-2.5 text-center font-heading text-[0.9rem] font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#A87C2C] transition-colors duration-150 ease-out hover:bg-[#E4B662] active:translate-y-[3px] active:shadow-[0_2px_0_0_#A87C2C] sm:text-lg ${className}`} data-id="element-27" data-mp="2fya4d8chqt3n">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.66rem] font-semibold normal-case tracking-normal text-navy/80" data-id="element-28" data-mp="3cqdq6bcfk2z6">
          {sub}
        </span> : null}
    </a>;
}
export function TrustLine({
  className = ''
}: {
  className?: string;
}) {
  return <p className={`text-center font-body text-[0.62rem] font-bold uppercase tracking-wide text-muted sm:text-xs ${className}`} data-id="element-29" data-mp="1d9yl1tjca085">
      🛡️ 7-Day Money-Back Guarantee <span className="text-gold" data-id="element-30" data-mp="1ibxnn1798t41">•</span> 🧹
      Complete 6-in-1 System
    </p>;
}